import { createAction } from "redux-actions";
import * as types from "./constants";
import { apiGet } from "../../util/api";

export const soloUIDFetchRequest = createAction(types.SOLO_UID_FETCH_REQUEST);
export const soloUIDFetchSuccess = createAction(types.SOLO_UID_FETCH_SUCCESS);
export const soloUIDFetchError = createAction(types.SOLO_UID_FETCH_ERROR);

// ASYNC ACTION FOR FETCHING SOLO UNIT ID
export const soloUIDFetch = () => dispatch => {
  dispatch(soloUIDFetchRequest());
  apiGet("/solo/views/lookup_solo_unit?limit=0")
    .then(res => res.json())
    .then(json => dispatch(soloUIDFetchSuccess(json)))
    .catch(err => dispatch(soloUIDFetchError(err)));
};
